import { ReportSubject } from "../entities/getReportSubject";
import { MatchRepository } from "../repositories/MatchRepository";

export class GetReportSubject {
	constructor(private repository: MatchRepository) {}
	execute(): Promise<ReportSubject[]> {
		return this.repository.getReportSubject();
	}
}
